import { render, staticRenderFns } from "./UserBatchDialog.vue?vue&type=template&id=7005bcc8&scoped=true&"
import script from "./UserBatchDialog.vue?vue&type=script&lang=js&"
export * from "./UserBatchDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserBatchDialog.vue?vue&type=style&index=0&id=7005bcc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7005bcc8",
  null
  
)

export default component.exports